import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";
import styles from "./nav.module.scss";

export const Nav = ({ onLogout }) => {
  const navigate = useNavigate();

  const [showLinks, setShowLinks] = useState(false);

  const handleShowlinks = () => {
    setShowLinks(!showLinks);
  };
  const handleLinkClick = () => {
    setShowLinks(false);
  };

  return (
    <nav className={`${styles.navbar} ${showLinks ? styles.showNav : ""}`}>
      <div className={styles.navbar_logo}>
        <NavLink to="/home">Freezer System</NavLink>
      </div>

      <ul className={styles.navbar_links}>
        <li
          className={`${styles.navbar_item} ${
            showLinks ? styles["slideInDown-4"] : ""
          }`}
        >
          <NavLink to="/freezer" onClick={handleLinkClick}>
            Freezer
          </NavLink>
        </li>
        <li
          className={`${styles.navbar_item} ${
            showLinks ? styles["slideInDown-4"] : ""
          }`}
        >
          <NavLink to="/member" onClick={handleLinkClick}>
            Mon compte
          </NavLink>
        </li>
      </ul>
      <div className={styles.navbar_burger} onClick={handleShowlinks}>
        <span className={styles.burger_bar}></span>
      </div>
      <li
        className={`${styles.navbar_item} ${
          showLinks ? styles["slideInDown-2"] : ""
        }`}
      >
        <button onClick={onLogout} className={styles.logoutButton}>
          Disconekt
        </button>
      </li>
    </nav>
  );
};

export default Nav;
